import type { FC, ReactNode } from "react";
import { cn } from "./utils/cn";

interface FloatingLabelProps {
  children: ReactNode;
  htmlFor?: string;
  required?: boolean;
  error?: boolean;
}

/**
 * Label that sits ON the top border of a field (the "notched outline" look used
 * by the Historic Worth compact dropdowns). Its `bg-surface` background cuts the
 * border so the text appears to straddle it. The parent field container must be
 * `group relative` so the label can color itself on focus via `group-focus-within`.
 */
const FloatingLabel: FC<FloatingLabelProps> = ({
  children,
  htmlFor,
  required,
  error,
}) => (
  <label
    htmlFor={htmlFor}
    className={cn(
      "transition-colors pointer-events-none absolute -top-2 start-3 z-[1] max-w-[calc(100%-1.5rem)] truncate bg-surface px-1 text-xs font-medium leading-none",
      error ? "text-danger" : "text-menu/70 group-focus-within:text-secondary"
    )}
  >
    {children}
    {required && <span className="text-danger"> *</span>}
  </label>
);

export default FloatingLabel;
